// "Classic" is the app's original look - untouched, kept around because it's
// what the primary user is used to. "Warm" is a second color palette,
// switchable at runtime (see useDesignMode). The two only ever differ in
// color - background and a few accent text elements (dates) - never in
// layout or fonts, which are shared across every theme. Key names are kept
// identical across all four objects so every component that reads
// theme.card/theme.text/etc. works unchanged no matter which is active.

export const classicLightTheme = {
  mode: "classic",
  scheme: "light",
  body: "#FFF",
  text: "#363537",
  card: "#fff",
  cardBorder: "solid rgb(51, 51, 51, 0.3) 1px",
  disabledText: "#d9d9d9",
  hoverBtn: "#DDD",
  paginationBtn: "#007bff",
  logo:
    "invert(21%) sepia(8%) saturate(141%) hue-rotate(227deg) brightness(91%) contrast(97%)",
};

export const classicDarkTheme = {
  mode: "classic",
  scheme: "dark",
  body: "#18191a",
  text: "#c5c9d3",
  card: "#242526",
  cardBorder: "solid #242526 1px",
  formControl: "#bdc0c1",
  disabledText: "#4d4d4d",
  hoverBtn: "#2d2d2e",
  paginationBtn: "#c5c9d3",
  logo:
    "invert(96%) sepia(0%) saturate(17%) hue-rotate(338deg) brightness(105%) contrast(103%)",
};

// "Warm" - a warm paper/leather color palette. Same layout, same fonts as
// classic - only the background and a few accent text elements (like dates)
// change.
export const warmLightTheme = {
  mode: "warm",
  scheme: "light",
  body: "#F1ECE1",
  card: "#FAF7F0",
  cardBorder: "solid rgba(36, 31, 25, 0.12) 1px",
  hoverBtn: "#EDE6D6",
  text: "#241F19",
  disabledText: "#8C8272",
  accent: "#9C6B2E",
  accentHover: "#B8813C",
  paginationBtn: "#9C6B2E",
  danger: "#8C3F2B",
  formControl: "#FAF7F0",
  logo:
    "invert(21%) sepia(8%) saturate(141%) hue-rotate(227deg) brightness(91%) contrast(97%)",
};

export const warmDarkTheme = {
  mode: "warm",
  scheme: "dark",
  body: "#14120E",
  card: "#1F1B15",
  cardBorder: "solid rgba(199, 154, 86, 0.14) 1px",
  hoverBtn: "#29241C",
  text: "#E9E2D3",
  disabledText: "#8A7F6C",
  accent: "#C79A56",
  accentHover: "#E0B36E",
  paginationBtn: "#C79A56",
  danger: "#A6553A",
  formControl: "#1F1B15",
  logo:
    "invert(96%) sepia(0%) saturate(17%) hue-rotate(338deg) brightness(105%) contrast(103%)",
};
